<template>
  <!--
    	作者：wangxw
    	时间：2019-11-05
    	描述：diy组件 搜索栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>
    
      <!-- 标题内容 -->
      <el-form-item label="标题内容：">
        <el-input v-model="curItem.params.text" class="w-auto"></el-input>
      </el-form-item>

       <el-form-item label="问题内容：">
        <el-input v-model="curItem.params.context" class="w-auto"></el-input>
      </el-form-item>

      <el-form-item label="业内现状" >
        <el-button size="small" type="primary" @click="addOrder1" >新增现状</el-button>
        <el-table :data="curItem.params.industry"  border size="mini" style="width: 100%;margin-top: 20px;">

         <el-table-column prop="industryimg" label="图片">
  <template v-slot="scope">
    <div class="draggable-list">
      <!-- 只显示一张图片 -->
      <div v-if="scope.row.industryimg && scope.row.industryimg.length > 0" class="item">
        <img v-img-url="scope.row.industryimg[0].file_path" alt="现状图片"/>
        <a href="javascript:void(0);" class="delete-btn" 
           @click.stop="deleteIndustryImg(scope.$index)">
          <i class="el-icon-close"></i>
        </a>
      </div>
      <!-- 上传按钮，没有图片时才显示 -->
      <div v-else class="item img-select" 
           @click="openProductUpload('industry', scope.$index)">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </template>
</el-table-column>

            <el-table-column prop="name" label="业内现状"   >
              <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="textarea" v-model="scope.row.advantage"  placeholder="请输入业内现状"></el-input>
                 
                  </div>
                </div>
    
              </template>
            </el-table-column>     


  
           <el-table-column prop="name" label="操作" width="100">
  <template v-slot="scope">
    <el-button 
      size="mini" 
      type="danger" 
      @click="deleteIndustryItem(scope.$index)">
      删除
    </el-button>
  </template>
</el-table-column>
          </el-table>
      </el-form-item> 


       <el-form-item label="优势" >
        <el-button size="small" type="primary" @click="addOrder" >新增优势</el-button>
        <el-table :data="curItem.params.order"  border size="mini" style="width: 100%;margin-top: 20px;">

          <el-table-column prop="name" label="排序" width="100" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 150px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>
            </el-table-column>


            <el-table-column prop="name" label="优势"   >
              <template v-slot="scope">
                <div>
                  <div class="d-s-c">
                    <el-input style="width: 650px;" type="textarea" v-model="scope.row.advantage"  placeholder="请输入公告记录"></el-input>
                 
                  </div>
                </div>
    
              </template>
            </el-table-column>     


  
            <el-table-column prop="name" label="操作" width="100">
  <template v-slot="scope">
    <el-button 
      size="mini" 
      type="danger" 
      @click="deleteAdvantageItem(scope.$index)">
      删除
    </el-button>
  </template>
</el-table-column>
          </el-table>
      </el-form-item> 

       <el-form-item label="流程图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="curItem.image">
          <transition-group>
            <div v-for="(item, index) in curItem.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
               <a href="javascript:void(0);" class="delete-btn" 
   @click.stop="deleteImg(index, 'album')">
  <i class="el-icon-close"></i>
</a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

    </el-form>
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
</template>

<script>
import { create } from 'lodash';
import Upload from '@/components/file/Upload';

  export default {
     components: {
     /*图片上传*/
     Upload: Upload,
  },
    data() {
      return {
           is_linkset: false,
                index: null,
                isProductUpload:false,
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {
      if(! this.curItem.params.order){
        this.curItem.params.order = [];
          }  
       if(! this.curItem.params.industry){
        this.curItem.params.industry = [];
          } 
    },
    methods: {
    openProductUpload(code, index = null) {
    // 如果是业内现状且已有图片，不允许再上传
    if (code === 'industry' && index !== null && 
        this.curItem.params.industry[index].industryimg && 
        this.curItem.params.industry[index].industryimg.length > 0) {
      this.$message.warning('每个现状只能上传一张图片');
      return;
    }
    this.isProductUpload = true;
    this.code = code;
    this.index = index;
  },

// 删除业内现状项
  deleteIndustryItem(index) {
    this.curItem.params.industry.splice(index, 1);
  },
  
  // 删除优势项
  deleteAdvantageItem(index) {
    this.curItem.params.order.splice(index, 1);
  },
  
  // 删除业内现状中的图片
  deleteIndustryImg(index) {
    this.$set(this.curItem.params.industry[index], 'industryimg', []);
  },
  
  /*上传商品图片*/
returnProductImgsFunc(e) {
  if (e != null) {
    // 验证图片格式
    let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
    let prevent = false;
    
    e.forEach((element) => {
      let data_array = element.file_path.split(".");
      let ext = data_array[data_array.length - 1];
      imgExpt.forEach((e) => {
        if (e === ext) {
          prevent = true
          return false
        }
      });
    });

    if (!prevent) {
      this.$message.error("图片类型有误,请选择正确的图片格式");
      return false;
    }

    if (this.code === 'industry') {
      // 上传到业内现状的图片
      if (this.index !== null) {
        const imgs = this.curItem.params.industry[this.index].industryimg 
          ? [...this.curItem.params.industry[this.index].industryimg, ...e] 
          : [...e];
        this.$set(this.curItem.params.industry[this.index], 'industryimg', imgs);
      }
    } else if (this.code === 'album') {
      // 上传到流程图片
      let imgs = this.curItem.image ? [...this.curItem.image, ...e] : [...e];
      this.$set(this.curItem, "image", imgs);
    }
  }
  this.isProductUpload = false;
},
  
deleteImg(index, code, industryIndex = null) {
  if (code === 'album') {
    this.curItem.image.splice(index, 1);
  } else if (code === 'industry' && industryIndex !== null) {
    this.curItem.params.industry[industryIndex].industryimg.splice(index, 1);
  }
},

    addOrder1(){
    this.curItem.params.industry.push({
      "code":this.randomString(8,this.randomString(6,0)),
      "sort":50,
      advantage: '', // 现状文本
      industryimg: [] // 该现状专属图片数组
    });
  },
  
  addOrder(){
    this.curItem.params.order.push({
      "code":this.randomString(8,this.randomString(6,0)),
      "sort":50,
      "name":"",
    });
  }
    }
  };
</script>

<style>
.diy-notice-icon, .diy-notice-icon img{ width: 32px; height: 32px;}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Slideimg.vue